import { render } from "./StandalonePopup.vue?vue&type=template&id=3781c86b"
import script from "./StandalonePopup.vue?vue&type=script&lang=js"
export * from "./StandalonePopup.vue?vue&type=script&lang=js"

import "./StandalonePopup.vue?vue&type=style&index=0&id=3781c86b&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__